import React from 'react';
import Icon from 'components/blocks/Icon/Icon';
import heroImg from 'img/NewDesign/img/imagenHome.png';
import './PublicMutua.scss';

const PublicMutua: React.FC = () => {
  return (
    <section className="trust">
      <div className="container">
        <div className="trust__card reveal is-in">
          <div className="trust__media">
            <img src={heroImg} alt="Profesionales Solimat" />
            <div className="trust__media-shade"></div>
            <div className="trust__badge">
              <Icon name="shield" size={18} />
              <span>Mutua nº 72</span>
            </div>
          </div>
          <div className="trust__body">
            <span className="eyebrow eyebrow--accent">Solimat contigo</span>
            <h2 className="trust__title">Cuidamos de ti<br />en cada paso del camino.</h2>
            <p className="trust__lede">
              Más de 80 años acompañando a trabajadores y empresas en accidentes
              laborales, enfermedades profesionales y contingencias comunes.
            </p>
            <ul className="trust__list">
              <li>
                <span className="trust__check"><Icon name="check" size={14} /></span>
                  Atención sanitaria 24 h en el Hospital Laboral de Toledo              </li>
              <li>
                <span className="trust__check"><Icon name="check" size={14} /></span>
                Tu gestor personal desde el inicio de la prestación
              </li>
              <li>
                <span className="trust__check"><Icon name="check" size={14} /></span>
                Toda tu información disponible online y en la app
              </li>
            </ul>
            <div className="trust__cta">
              <button className="btn btn--secondary">
                <Icon name="phone" size={16} /> 900 111 072
              </button>
              <a
                className="trust__link"
                href="https://www.solimat.com/#perfil=autonomo"
                target="_blank"
                rel="noopener noreferrer"
              >
                Conoce a Solimat <Icon name="arrow-right" size={16} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PublicMutua;
